import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import "./index.scss"
import { menu } from '../route-menu'
import { useNavigate, useLocation } from 'react-router-dom';

export default function HomeNav() {
    const navigate = useNavigate()
        , location = useLocation()

    useEffect(() => {
        const path = location.pathname;

        const newSelectedKeys = menu
            .filter(item => path.startsWith(item.key))
            .map(item => item.key);

        if (newSelectedKeys.length === 0) {
            // 如果没有匹配的路由，使用第一个路由的 key
            setSelectedKeys([menu[0].key]);
            navigate(menu[0].key); // 进行路由跳转
        } else {
            setSelectedKeys(newSelectedKeys);
        }
    }, [location.pathname]);

    const [selectedKeys, setSelectedKeys] = useState([]);

    const onSelect = (e) => {
        const { domEvent, item, key } = e;
        setSelectedKeys([key]);
        navigate(key, { state: { title: domEvent.currentTarget.innerText, role: item.props.role } });
    }

    return (
        <div className='user-menu-container'>
            <Menu
                mode='vertical'
                items={menu}
                onSelect={onSelect}
                selectedKeys={selectedKeys}
            />
        </div>
    );
}
